//
import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"

import { TeamUserFilter, TeamOrganizationFilter } from "shared/search/containers/Filter/TeamFilters"

export const TeamReferenceFilterGroup = (props) => genericFilterGroup(props)
TeamReferenceFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
TeamReferenceFilterGroup.defaultProps = {
    filters: [TeamUserFilter, TeamOrganizationFilter],
    uniqueFilterGroupId: "teamReferenceFilterGroup",
    displayLabel: "Referencing",
    helpText: "Filter votes by association with a specific User or Organization",
}
